/**
 * Reluxe Instant Search - NEXT GENERATION
 * Better than Fashionphile, Rebag, TheRealReal
 *
 * Features:
 * - Instant search-as-you-type with visual preview (<50ms)
 * - Smart suggestions (trending, recent, autocomplete)
 * - Visual product previews in dropdown
 * - Keyboard navigation
 * - Mobile-optimized
 * - Recently viewed products
 * - Personalized recommendations
 */

console.log('[ReluxeSearch] Script loaded - v10.1 (details[open] check)');

(function() {
  'use strict';

  // Algolia Configuration
  const ALGOLIA_APP_ID = '18OR3RE3S6';
  const ALGOLIA_SEARCH_KEY = 'f990a8cbd4fd415d210a6f3c4dcd060f';
  const ALGOLIA_INDEX_NAME = 'products';

  // Initialize Algolia
  let searchClient = null;
  let searchIndex = null;

  // State
  let selectedIndex = -1;
  let recentSearches = [];
  let recentlyViewed = [];
  let trendingSearches = ['Louis Vuitton', 'Chanel Bag', 'Hermes Birkin', 'Gucci', 'Dior'];

  // Load from localStorage
  function loadLocalData() {
    try {
      recentSearches = JSON.parse(localStorage.getItem('reluxe_recent_searches') || '[]').slice(0, 5);
      recentlyViewed = JSON.parse(localStorage.getItem('reluxe_recently_viewed') || '[]').slice(0, 8);
    } catch (e) {}
  }

  function saveRecentSearch(query) {
    if (!query || query.length < 2) return;
    recentSearches = [query, ...recentSearches.filter(s => s !== query)].slice(0, 5);
    localStorage.setItem('reluxe_recent_searches', JSON.stringify(recentSearches));
  }

  function saveRecentlyViewed(product) {
    if (!product || !product.handle) return;
    recentlyViewed = [product, ...recentlyViewed.filter(p => p.handle !== product.handle)].slice(0, 8);
    localStorage.setItem('reluxe_recently_viewed', JSON.stringify(recentlyViewed));
  }

  // Initialize Algolia client
  function initAlgolia() {
    if (typeof algoliasearch === 'undefined') {
      console.error('[ReluxeSearch] Algolia library not loaded');
      return false;
    }
    searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY);
    searchIndex = searchClient.initIndex(ALGOLIA_INDEX_NAME);
    return true;
  }

  // Debounce helper
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // Optimize image URL
  function optimizeImageUrl(url, width = 200) {
    if (!url) return 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';
    if (url.includes('cloudinary.com')) {
      return url.replace('/c_pad,', `/c_pad,w_${width},q_auto,f_auto,`);
    }
    return url;
  }

  // Format price
  function formatPrice(price) {
    return '$' + (price || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Search Algolia
  async function search(query) {
    if (!searchIndex) return { hits: [], nbHits: 0 };

    const startTime = performance.now();

    try {
      const results = await searchIndex.search(query, {
        hitsPerPage: 8,
        attributesToRetrieve: ['objectID', 'sku', 'title', 'brand', 'price', 'image', 'handle', 'category', 'product_type'],
        attributesToHighlight: ['title', 'brand']
      });

      const endTime = performance.now();
      results.clientTime = Math.round(endTime - startTime);

      return results;
    } catch (e) {
      console.error('[ReluxeSearch] Search error:', e);
      return { hits: [], nbHits: 0 };
    }
  }

  // Our dropdown element
  let dropdown = null;

  // Check if the search modal is currently visible
  function isSearchModalVisible() {
    // Check for details[open] pattern (Shopify's modal system)
    const openDetails = document.querySelector('details[open] .search-modal, details[open] .search-modal__content');
    if (openDetails) {
      return true;
    }

    // Also check for details-modal with open attribute
    const detailsModal = document.querySelector('details-modal[open], details[open][data-modal="search"]');
    if (detailsModal) {
      return true;
    }

    // Fallback: check if the search input is visible and has dimensions
    const input = document.querySelector('#Search-In-Modal, #Search-In-Modal-1');
    if (input) {
      const rect = input.getBoundingClientRect();
      // Input must have actual dimensions to be visible
      if (rect.width > 0 && rect.height > 0 && rect.top >= 0) {
        return true;
      }
    }

    return false;
  }

  // Create our dropdown element
  function createDropdown() {
    if (dropdown) return dropdown;

    dropdown = document.createElement('div');
    dropdown.className = 'reluxe-instant-search__dropdown';
    dropdown.innerHTML = '<div class="reluxe-instant-search__loading">Searching...</div>';
    document.body.appendChild(dropdown);

    return dropdown;
  }

  // Position dropdown below the input
  function positionDropdown(input) {
    if (!dropdown) return;
    const rect = input.getBoundingClientRect();
    dropdown.style.position = 'fixed';
    dropdown.style.top = (rect.bottom + 8) + 'px';
    dropdown.style.left = '0';
    dropdown.style.right = '0';
    dropdown.style.width = '100%';
  }

  // Open dropdown (only if modal is visible)
  function openDropdown() {
    if (!dropdown) return;

    // KEY FIX: Only open if modal is actually visible
    if (!isSearchModalVisible()) {
      console.log('[ReluxeSearch] Not opening - search modal not visible');
      return;
    }

    dropdown.classList.add('reluxe-instant-search__dropdown--open');
  }

  // Close dropdown
  function closeDropdown() {
    if (!dropdown) return;
    dropdown.classList.remove('reluxe-instant-search__dropdown--open');
    selectedIndex = -1;
  }

  // Enhance a single search input with Algolia instant search
  function enhanceInput(input) {
    if (input.dataset.reluxeEnhanced) {
      return;
    }
    input.dataset.reluxeEnhanced = 'true';

    console.log('[ReluxeSearch] Enhancing input:', input.id || input.className || input.name);

    // Disable Shopify's predictive search on this input
    input.removeAttribute('aria-controls');
    input.removeAttribute('aria-owns');
    input.removeAttribute('aria-haspopup');
    input.removeAttribute('aria-autocomplete');
    input.removeAttribute('aria-expanded');
    input.setAttribute('autocomplete', 'off');

    // Create dropdown
    createDropdown();

    // Add event listeners with capture to run before Shopify
    const debouncedHandler = debounce((e) => handleInput(e), 150);

    input.addEventListener('input', (e) => {
      e.stopPropagation();
      positionDropdown(input);
      debouncedHandler(e);
    }, true);

    input.addEventListener('focus', (e) => {
      e.stopPropagation();
      positionDropdown(input);
      handleFocus(e);
    }, true);

    input.addEventListener('keydown', (e) => handleKeydown(e));

    input.addEventListener('keyup', (e) => {
      e.stopPropagation();
    }, true);

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (!input.contains(e.target) && !dropdown.contains(e.target)) {
        closeDropdown();
      }
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeDropdown();
      }
    });

    console.log('[ReluxeSearch] Input enhanced');
  }

  // Create the instant search UI
  function createSearchUI() {
    const selectors = [
      '#Search-In-Modal',
      '#Search-In-Modal-1',
      '#Search-In-Template',
      'predictive-search input[type="search"]',
      'predictive-search input[name="q"]',
      '.search__input[type="search"]',
      'form[action="/search"] input[type="search"]',
      'form[action="/search"] input[name="q"]:not([type="hidden"])'
    ];

    const existingInputs = document.querySelectorAll(selectors.join(', '));
    console.log('[ReluxeSearch] Found', existingInputs.length, 'search inputs');

    existingInputs.forEach((input) => {
      enhanceInput(input);
    });

    // Watch for search modal opening
    observeSearchModal();
  }

  // Watch for search modal to open
  function observeSearchModal() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            const input = node.querySelector?.('#Search-In-Modal, #Search-In-Modal-1, predictive-search input[type="search"]');
            if (input && !input.dataset.reluxeEnhanced) {
              enhanceInput(input);
              setTimeout(() => {
                positionDropdown(input);
                showDefaultState();
                openDropdown();
              }, 50);
            }
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also listen for click on search icon
    document.addEventListener('click', (e) => {
      const searchTrigger = e.target.closest('a[href*="/search"], button[aria-label*="Search"], button[aria-label*="search"], .header__icon--search, [data-modal-open="search"]');
      if (searchTrigger) {
        setTimeout(() => {
          const input = document.querySelector('#Search-In-Modal, #Search-In-Modal-1, predictive-search input[type="search"]');
          if (input) {
            if (!input.dataset.reluxeEnhanced) {
              enhanceInput(input);
            }
            positionDropdown(input);
            showDefaultState();
            openDropdown();
          }
        }, 150);
      }
    }, true);
  }

  // Handle input changes
  async function handleInput(e) {
    if (!dropdown) return;

    const query = e.target.value.trim();

    if (query.length < 2) {
      showDefaultState();
      openDropdown();
      return;
    }

    dropdown.innerHTML = '<div class="reluxe-instant-search__loading"><div class="reluxe-spinner-small"></div>Searching...</div>';
    openDropdown();

    const results = await search(query);
    renderResults(query, results);
  }

  // Handle focus
  function handleFocus(e) {
    if (!dropdown) return;

    const query = e.target.value.trim();
    if (query.length >= 2) {
      search(query).then(results => {
        renderResults(query, results);
        openDropdown();
      });
    } else {
      showDefaultState();
      openDropdown();
    }
  }

  // Handle keyboard navigation
  function handleKeydown(e) {
    if (!dropdown) return;

    const items = dropdown.querySelectorAll('.reluxe-search-panel__product, .reluxe-search-panel__tag, .reluxe-search-panel__designer');

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        selectedIndex = Math.min(selectedIndex + 1, items.length - 1);
        updateSelection(items);
        break;
      case 'ArrowUp':
        e.preventDefault();
        selectedIndex = Math.max(selectedIndex - 1, -1);
        updateSelection(items);
        break;
      case 'Enter':
        if (selectedIndex >= 0 && items[selectedIndex]) {
          e.preventDefault();
          const link = items[selectedIndex].closest('a') || items[selectedIndex];
          if (link.href) window.location.href = link.href;
        }
        break;
      case 'Escape':
        closeDropdown();
        break;
    }
  }

  function updateSelection(items) {
    items.forEach((item, i) => {
      item.classList.toggle('reluxe-instant-search__item--selected', i === selectedIndex);
    });
  }

  // Top designers
  const topDesigners = ['Louis Vuitton', 'Chanel', 'Gucci', 'Hermès', 'Prada', 'Dior', 'Balenciaga', 'Bottega Veneta', 'YSL', 'Fendi', 'Celine'];

  // Show default state
  function showDefaultState() {
    if (!dropdown) return;

    dropdown.innerHTML = `
      <div class="reluxe-search-panel">
        <div class="reluxe-search-panel__inner">
          <div class="reluxe-search-panel__left">
            ${recentSearches.length > 0 ? `
              <div class="reluxe-search-panel__section">
                <h3 class="reluxe-search-panel__title">Recent Searches</h3>
                <div class="reluxe-search-panel__list">
                  ${recentSearches.map(s => `
                    <a href="/search?q=${encodeURIComponent(s)}" class="reluxe-search-panel__link">${s}</a>
                  `).join('')}
                </div>
              </div>
            ` : ''}
          </div>
          <div class="reluxe-search-panel__right">
            <div class="reluxe-search-panel__section">
              <h3 class="reluxe-search-panel__title">Trending Searches</h3>
              <div class="reluxe-search-panel__tags">
                ${trendingSearches.map(s => `
                  <a href="/search?q=${encodeURIComponent(s)}" class="reluxe-search-panel__tag">${s}</a>
                `).join('')}
              </div>
            </div>
          </div>
        </div>
        <div class="reluxe-search-panel__designers">
          <h3 class="reluxe-search-panel__title">Shop by Designer</h3>
          <div class="reluxe-search-panel__designer-grid">
            ${topDesigners.map(d => `
              <a href="/collections/${d.toLowerCase().replace(/\s+/g, '-')}" class="reluxe-search-panel__designer">${d}</a>
            `).join('')}
          </div>
        </div>
      </div>
    `;
    selectedIndex = -1;
  }

  // Render search results
  function renderResults(query, results) {
    if (!dropdown) return;

    const { hits, nbHits } = results;

    if (hits.length === 0) {
      dropdown.innerHTML = `
        <div class="reluxe-search-panel">
          <div class="reluxe-search-panel__no-results">
            <p>No results for "<strong>${query}</strong>"</p>
            <p>Try a different search term or browse our collections</p>
          </div>
        </div>
      `;
      return;
    }

    let productsHtml = '';
    hits.slice(0, 8).forEach((hit, index) => {
      const title = hit.title || '';
      const brand = hit.brand || '';

      productsHtml += `
        <a href="/products/${hit.handle}" class="reluxe-search-panel__product" data-index="${index}">
          <div class="reluxe-search-panel__product-image">
            <img src="${optimizeImageUrl(hit.image, 150)}" alt="${title}" loading="eager">
          </div>
          <div class="reluxe-search-panel__product-info">
            <span class="reluxe-search-panel__product-brand">${brand}</span>
            <span class="reluxe-search-panel__product-title">${title}</span>
            <span class="reluxe-search-panel__product-price">${formatPrice(hit.price)}</span>
          </div>
        </a>
      `;
    });

    dropdown.innerHTML = `
      <div class="reluxe-search-panel reluxe-search-panel--results">
        <div class="reluxe-search-panel__layout">
          <div class="reluxe-search-panel__products-side">
            <div class="reluxe-search-panel__results-header">
              <span class="reluxe-search-panel__results-count">${nbHits.toLocaleString()} results for "${query}"</span>
            </div>
            <div class="reluxe-search-panel__products-grid">
              ${productsHtml}
            </div>
            <a href="/search?q=${encodeURIComponent(query)}" class="reluxe-search-panel__view-all">
              View all ${nbHits.toLocaleString()} results
            </a>
          </div>
          <div class="reluxe-search-panel__sidebar">
            <div class="reluxe-search-panel__section">
              <h3 class="reluxe-search-panel__title">Trending Searches</h3>
              <div class="reluxe-search-panel__tags">
                ${trendingSearches.map(s => `
                  <a href="/search?q=${encodeURIComponent(s)}" class="reluxe-search-panel__tag">${s}</a>
                `).join('')}
              </div>
            </div>
            <div class="reluxe-search-panel__section">
              <h3 class="reluxe-search-panel__title">Shop by Designer</h3>
              <div class="reluxe-search-panel__designer-list">
                ${topDesigners.map(d => `
                  <a href="/collections/${d.toLowerCase().replace(/\s+/g, '-')}" class="reluxe-search-panel__designer-link">${d}</a>
                `).join('')}
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    selectedIndex = -1;
    saveRecentSearch(query);
  }

  // Inject styles
  function injectStyles() {
    if (document.getElementById('reluxe-instant-search-styles')) return;

    const styles = document.createElement('style');
    styles.id = 'reluxe-instant-search-styles';
    styles.textContent = `
      /* Hide Shopify predictive search */
      predictive-search .predictive-search,
      predictive-search .predictive-search__results-groups-wrapper,
      .predictive-search__results-groups-wrapper,
      .predictive-search__results,
      .predictive-search__result-group,
      #predictive-search-results,
      .predictive-search__results-list,
      .predictive-search__loading-state {
        display: none !important;
        visibility: hidden !important;
        height: 0 !important;
        overflow: hidden !important;
      }

      /* Our dropdown */
      .reluxe-instant-search__dropdown {
        position: fixed;
        left: 0;
        right: 0;
        background: white;
        border-top: 1px solid #e5e7eb;
        box-shadow: 0 20px 60px rgba(0,0,0,0.15);
        z-index: 999999 !important;
        display: none;
        overflow: hidden;
      }

      .reluxe-instant-search__dropdown--open {
        display: block;
        animation: reluxe-slideDown 0.2s ease;
      }

      @keyframes reluxe-slideDown {
        from { opacity: 0; transform: translateY(-10px); }
        to { opacity: 1; transform: translateY(0); }
      }

      .reluxe-instant-search__loading {
        padding: 40px;
        text-align: center;
        color: #6b7280;
      }

      .reluxe-spinner-small {
        display: inline-block;
        width: 20px;
        height: 20px;
        border: 2px solid #e5e7eb;
        border-top-color: #111;
        border-radius: 50%;
        animation: reluxe-spin 0.6s linear infinite;
        margin-right: 10px;
        vertical-align: middle;
      }

      @keyframes reluxe-spin {
        to { transform: rotate(360deg); }
      }

      .reluxe-search-panel {
        max-width: 1400px;
        margin: 0 auto;
        padding: 30px 40px;
      }

      .reluxe-search-panel__inner {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 60px;
        margin-bottom: 30px;
      }

      .reluxe-search-panel__section {
        margin-bottom: 20px;
      }

      .reluxe-search-panel__title {
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1.5px;
        color: #9ca3af;
        margin: 0 0 16px 0;
      }

      .reluxe-search-panel__list {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      .reluxe-search-panel__link {
        color: #374151;
        text-decoration: none;
        font-size: 15px;
        transition: color 0.15s;
      }

      .reluxe-search-panel__link:hover {
        color: #111;
      }

      .reluxe-search-panel__tags {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
      }

      .reluxe-search-panel__tag {
        padding: 10px 20px;
        background: #f3f4f6;
        color: #374151;
        border-radius: 25px;
        font-size: 14px;
        text-decoration: none;
        transition: all 0.15s;
      }

      .reluxe-search-panel__tag:hover {
        background: #111;
        color: white;
      }

      .reluxe-search-panel__designers {
        border-top: 1px solid #f3f4f6;
        padding-top: 25px;
      }

      .reluxe-search-panel__designer-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
      }

      .reluxe-search-panel__designer {
        padding: 8px 18px;
        border: 1px solid #e5e7eb;
        border-radius: 20px;
        color: #374151;
        font-size: 13px;
        text-decoration: none;
        transition: all 0.15s;
      }

      .reluxe-search-panel__designer:hover {
        border-color: #111;
        background: #111;
        color: white;
      }

      .reluxe-search-panel--results {
        padding: 20px 30px 25px;
      }

      .reluxe-search-panel__layout {
        display: grid;
        grid-template-columns: 1fr 220px;
        gap: 30px;
      }

      .reluxe-search-panel__products-side {
        min-width: 0;
      }

      .reluxe-search-panel__results-header {
        margin-bottom: 12px;
      }

      .reluxe-search-panel__results-count {
        font-size: 13px;
        color: #6b7280;
      }

      .reluxe-search-panel__products-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(2, auto);
        gap: 12px;
        margin-bottom: 14px;
      }

      .reluxe-search-panel__product {
        text-decoration: none;
        color: inherit;
        display: block;
        max-width: 140px;
      }

      .reluxe-search-panel__product-image {
        width: 100%;
        max-width: 120px;
        aspect-ratio: 1;
        background: #f9fafb;
        border-radius: 4px;
        overflow: hidden;
        margin-bottom: 6px;
      }

      .reluxe-search-panel__product-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
      }

      .reluxe-search-panel__product:hover .reluxe-search-panel__product-image img {
        transform: scale(1.05);
      }

      .reluxe-search-panel__product-info {
        text-align: left;
        max-width: 120px;
      }

      .reluxe-search-panel__product-brand {
        display: block;
        font-size: 8px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.3px;
        color: #9ca3af;
        margin-bottom: 1px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .reluxe-search-panel__product-title {
        display: block;
        font-size: 10px;
        color: #374151;
        margin-bottom: 2px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .reluxe-search-panel__product-price {
        font-size: 11px;
        font-weight: 700;
        color: #111;
      }

      .reluxe-search-panel__view-all {
        display: block;
        text-align: center;
        padding: 10px 16px;
        background: #111;
        color: white;
        text-decoration: none;
        font-weight: 600;
        font-size: 12px;
        border-radius: 4px;
        transition: background 0.2s;
      }

      .reluxe-search-panel__view-all:hover {
        background: #333;
      }

      .reluxe-search-panel__sidebar {
        border-left: 1px solid #f3f4f6;
        padding-left: 25px;
      }

      .reluxe-search-panel__sidebar .reluxe-search-panel__section {
        margin-bottom: 20px;
      }

      .reluxe-search-panel__sidebar .reluxe-search-panel__tags {
        gap: 6px;
      }

      .reluxe-search-panel__sidebar .reluxe-search-panel__tag {
        padding: 6px 12px;
        font-size: 11px;
      }

      .reluxe-search-panel__designer-list {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }

      .reluxe-search-panel__designer-link {
        color: #374151;
        text-decoration: none;
        font-size: 12px;
        transition: color 0.15s;
      }

      .reluxe-search-panel__designer-link:hover {
        color: #111;
        text-decoration: underline;
      }

      .reluxe-search-panel__no-results {
        text-align: center;
        padding: 60px 20px;
      }

      .reluxe-search-panel__no-results p {
        margin: 0 0 8px;
        color: #374151;
      }

      .reluxe-search-panel__no-results p:last-child {
        color: #9ca3af;
        font-size: 14px;
      }

      @media (max-width: 1024px) {
        .reluxe-search-panel__layout {
          grid-template-columns: 1fr;
          gap: 25px;
        }

        .reluxe-search-panel__sidebar {
          border-left: none;
          border-top: 1px solid #f3f4f6;
          padding-left: 0;
          padding-top: 20px;
        }

        .reluxe-search-panel__products-grid {
          grid-template-columns: repeat(4, 1fr);
        }
      }

      @media (max-width: 768px) {
        .reluxe-instant-search__dropdown {
          position: fixed !important;
          top: auto !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          width: 100% !important;
          max-height: 60vh !important;
          overflow-y: auto !important;
          border-top: 1px solid #e5e7eb;
          border-radius: 16px 16px 0 0;
          box-shadow: 0 -4px 20px rgba(0,0,0,0.15);
        }

        .reluxe-search-panel {
          padding: 12px;
        }

        .reluxe-search-panel__inner,
        .reluxe-search-panel__right,
        .reluxe-search-panel__left,
        .reluxe-search-panel__designers,
        .reluxe-search-panel__sidebar {
          display: none !important;
        }

        .reluxe-search-panel__layout {
          display: block !important;
        }

        .reluxe-search-panel__results-header {
          margin-bottom: 10px;
          padding-bottom: 6px;
          border-bottom: 1px solid #f3f4f6;
        }

        .reluxe-search-panel__results-count {
          font-size: 11px;
        }

        .reluxe-search-panel__products-grid {
          display: flex !important;
          flex-wrap: wrap !important;
          gap: 8px !important;
        }

        .reluxe-search-panel__product {
          display: flex !important;
          flex-direction: row !important;
          align-items: center !important;
          width: 100% !important;
          max-width: none !important;
          padding: 8px;
          background: #f9fafb;
          border-radius: 8px;
          gap: 10px;
        }

        .reluxe-search-panel__product-image {
          width: 50px !important;
          height: 50px !important;
          min-width: 50px !important;
          max-width: 50px !important;
          aspect-ratio: 1;
          border-radius: 4px;
          margin-bottom: 0 !important;
        }

        .reluxe-search-panel__product-image img {
          width: 50px !important;
          height: 50px !important;
          object-fit: cover;
        }

        .reluxe-search-panel__product-info {
          flex: 1;
          min-width: 0;
          max-width: none;
          text-align: left;
        }

        .reluxe-search-panel__product-brand {
          font-size: 9px;
          margin-bottom: 2px;
        }

        .reluxe-search-panel__product-title {
          font-size: 12px;
          margin-bottom: 2px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .reluxe-search-panel__product-price {
          font-size: 12px;
          font-weight: 600;
        }

        .reluxe-search-panel--results {
          padding: 12px;
        }

        .reluxe-search-panel__view-all {
          padding: 12px;
          font-size: 13px;
          margin-top: 10px;
        }

        .reluxe-search-panel__no-results {
          padding: 30px 12px;
        }

        .reluxe-search-panel__no-results p {
          font-size: 14px;
        }

        .reluxe-instant-search__loading {
          padding: 24px;
          font-size: 13px;
        }
      }
    `;

    document.head.appendChild(styles);
  }

  // Track product views
  function trackProductView() {
    const path = window.location.pathname;
    if (!path.includes('/products/')) return;

    const productJson = document.querySelector('[data-product-json], script[type="application/json"][data-product-json]');
    if (productJson) {
      try {
        const product = JSON.parse(productJson.textContent);
        saveRecentlyViewed({
          handle: product.handle,
          title: product.title,
          price: product.price / 100,
          image: product.featured_image
        });
      } catch (e) {}
    }
  }

  // Initialize
  function init() {
    loadLocalData();
    injectStyles();

    if (initAlgolia()) {
      createSearchUI();
      trackProductView();
      console.log('[ReluxeSearch] Instant search initialized');
    }
  }

  // Public API
  window.ReluxeInstantSearch = {
    init: init,
    search: search
  };

  // Auto-initialize
  function waitForAlgolia(callback, maxWait = 5000) {
    const start = Date.now();
    function check() {
      if (typeof algoliasearch !== 'undefined') {
        callback();
      } else if (Date.now() - start < maxWait) {
        setTimeout(check, 100);
      } else {
        console.error('[ReluxeSearch] Algolia library failed to load after', maxWait, 'ms');
      }
    }
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForAlgolia(init));
  } else {
    waitForAlgolia(init);
  }

})();
